<div class="dialog-container">
  <ng-container *ngIf="data?.icon as icon">
    <div
      class="icon"
      [class.with-bg]="iconConfig.showBg"
      [ngStyle]="{
        background: iconConfig.showBg ? iconConfig.bgColor : 'transparent',
        color: iconConfig.color,
      }"
    >
      <img *ngIf="icon.type === 'img'" [src]="icon.src" />

      <mat-icon *ngIf="icon.type === 'mat-icon'">
        {{ icon.name }}
      </mat-icon>

      <div
        *ngIf="icon.type === 'svg'"
        [innerHTML]="icon.svg"
        class="svg-icon"
      ></div>

      <ng-container *ngIf="icon.type === 'template'">
        <ng-container *ngTemplateOutlet="icon.template"></ng-container>
      </ng-container>
    </div>
  </ng-container>

  <div class="content">
    <div class="dialog_title" *ngFor="let title of titles">
      {{ title | translate }}
    </div>

    <div class="message" *ngFor="let msg of messages">
      {{ msg | translate }}
    </div>

    <div class="diff" *ngIf="data?.diff?.length">
      <div class="diff-row" *ngFor="let d of data?.diff">
        <div class="label">{{ "view_value." + d.field | translate }}</div>
        <div class="old">{{ d.old || "-" }}</div>
        <mat-icon>arrow_forward</mat-icon>
        <div class="new">{{ d.new || "-" }}</div>
      </div>
    </div>

    <div class="field" *ngIf="data?.requirePassword">
      <xten-input-text
        [(ngModel)]="password"
        class="dialog-input"
        type="password"
        [placeholder]="data?.passwordConfig?.placeholder || 'กรอกรหัสผ่าน'"
        [showTogglePassword]="true"
      ></xten-input-text>
    </div>

    <div class="field" *ngIf="data?.formConfig">
      <ng-container *ngFor="let c of data!.formConfig!.controls">
        <xten-input-text
          [(ngModel)]="form[c.key]"
          [type]="c.type"
          [placeholder]="c.placeholder!"
          [showTogglePassword]="c.type === 'password'"
        ></xten-input-text>
      </ng-container>
    </div>

    <ng-container *ngIf="data?.customTemplate">
      <ng-container *ngTemplateOutlet="data!.customTemplate!"></ng-container>
    </ng-container>

    <div class="actions" [class.reverse]="data?.reverseButton">
      <button
        mat-stroked-button
        class="btn"
        [ngClass]="['btn-cancel', cancelVariant]"
        (click)="cancel()"
      >
        {{ cancelText | translate }}
      </button>

      <button
        mat-stroked-button
        class="btn"
        [ngClass]="['btn-confirm', confirmVariant]"
        (click)="agree()"
      >
        {{ confirmText | translate }}
      </button>
    </div>
  </div>
</div>
